import { Editor, Element, Node, NodeEntry, Path, Text, Transforms } from "slate";

import { IAgent } from "store/entities/agents";

import { RichEditor } from "../types";

const isParagraphNodeEmpty = (node: Node): boolean =>
  Element.isElement(node) &&
  node.type === "paragraph" &&
  node.children.length === 1 &&
  Text.isText(node.children[0]) &&
  node.children[0].text === "";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const convertEmptySignatureToParagraph = (editor: RichEditor, signaturePath: Path) => {
  Transforms.removeNodes(editor, { at: signaturePath });
  Transforms.insertNodes(editor, { type: "paragraph", children: [{ text: "" }] }, { at: signaturePath });
};

const getSignatureEntry = (editor: RichEditor): NodeEntry | undefined => {
  const signatureEntry = Array.from(
    Editor.nodes(editor, {
      at: [],
      mode: "all",
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      match: (node: any) => !Editor.isEditor(node) && Element.isElement(node) && Boolean(node.signature),
    })
  )[0];

  if (!signatureEntry) return undefined;

  const signatureNode = signatureEntry[0];
  const signaturePath = signatureEntry[1];
  const isSignatureNodeEmpty = isParagraphNodeEmpty(signatureNode);

  if (isSignatureNodeEmpty) {
    convertEmptySignatureToParagraph(editor, signaturePath);

    return undefined;
  }

  return signatureEntry;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const removePrecedingEmptyLinesAddedBySignature = (editor: RichEditor, signaturePath: Path) => {
  const [signatureParentNode] = Editor.parent(editor, signaturePath);
  const signatureParentPath = Path.parent(signaturePath);

  for (let i = signaturePath[0] - 1; i >= 0; i--) {
    const child = signatureParentNode.children[i];
    if (isParagraphNodeEmpty(child)) {
      Transforms.removeNodes(editor, { at: [...signatureParentPath, i] });
    } else {
      break;
    }
  }
};

export const hasSignatureInserted = (editor: RichEditor): boolean => Boolean(getSignatureEntry(editor));

export const isDefinedSignatureEmpty = (agentSignature: IAgent["signature"]): boolean => {
  const isNotEmptyRichTextSignatureDefined =
    !!agentSignature.richTextObj &&
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !agentSignature.richTextObj.reduce((empty: any, node: any) => isParagraphNodeEmpty(node) && empty, true);
  const isNotEmptyTextSignatureDefined = !!agentSignature.text && Boolean(agentSignature.text.trim());

  return !isNotEmptyRichTextSignatureDefined && !isNotEmptyTextSignatureDefined;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const removeSignature = (editor: RichEditor) => {
  const signatureEntry = getSignatureEntry(editor);

  if (!signatureEntry) return;

  const signaturePath = signatureEntry[1];
  Transforms.removeNodes(editor, { at: signaturePath });
  removePrecedingEmptyLinesAddedBySignature(editor, signaturePath);
};
